export const lockTypeConfig = {
  heading: "Serrures et accès",
  subtitle:
    "Comment le client entre-t-il dans votre logement ? Ajoutez une ou plusieurs serrures (entrée de l'immeuble, logement…), chacune avec son propre nom et type d'accès.",
  loading: "Chargement de la configuration…",

  enable: {
    title: "Envoyer les codes d'accès",
    sub:
      "Si vous désactivez cette option, nous n'enverrons pas les clés d'accès au client. Les instructions d'arrivée seront quand même envoyées, quel que soit ce paramètre.",
  },

  scope: {
    labelRoom: "Chambre à configurer",
    labelUnit: "Logement à configurer",
    hintRoom: "Chaque chambre conserve sa propre configuration d'accès.",
    hintUnit: "Chaque logement conserve sa propre configuration d'accès.",
  },

  conflict: {
    title: "Ces espaces n'utiliseront pas cette configuration",
    textBefore:
      "Ils conservent leurs propres clés, et lors de l'envoi, la configuration la plus spécifique l'emporte toujours.",
    textStrong: "Ce que vous modifiez ici ne leur parviendra pas",
    textAfter: "tant qu'ils restent ainsi :",
    lockCount: "serrure | serrures",
    applying: "Application…",
    applyAll: "Appliquer cette configuration à tous",
  },

  lockBadge: "Serrure {n}",
  removeLock: "Supprimer la serrure",
  nameLabel: "Nom de l'entrée",
  namePlaceholder: "Ou saisissez un nom…",
  typeLabel: "Type d'accès",
  codePlaceholderBox: "Code de la boîte à clés · ex. 5817",
  codePlaceholderLock: "Code de la serrure · ex. 5817",
  lockFallback: "Serrure",
  connectedSuffix: "connectée",
  editConfig: "Modifier la configuration",
  configure: "Configurer…",
  addLock: "Ajouter une autre serrure",
  roomsHint:
    "Chaque chambre physique a sa propre serrure et son propre code. Configurez-les ici, une par une.",

  wa: {
    online: "en ligne",
    today: "Aujourd'hui",
    captionOverriding: "Voici comment {source} le reçoit · pas les espaces mentionnés ci-dessus",
    captionPreview: "Aperçu · voici comment le client de {source} le recevra",
  },

  modal: {
    title: "Configurez votre serrure intelligente",
    sub: "Choisissez votre marque et connectez-la pour générer des clés automatiques par réservation.",
    close: "Fermer",
    note: "Ajoutez d'abord un logement à l'annonce pour configurer la serrure intelligente.",
  },

  providerOther: "Autre marque",

  presets: {
    main: "Entrée principale",
    property: "Entrée de la propriété",
    unit: "Entrée du logement",
  },

  entryFallback: "Entrée",
  roomFallback: "Chambre",
  yourProperty: "votre logement",

  types: {
    none: {
      title: "Boîte à clés",
      desc: "Une boîte sécurisée contenant les clés du logement.",
    },
    dynamic: {
      title: "Serrure intelligente",
      desc: "Une nouvelle clé automatique pour chaque réservation.",
    },
    static: {
      title: "Serrure à code statique",
      desc: "Un code que vous modifiez manuellement de temps en temps.",
    },
  },

  source: {
    room: "cette chambre",
    unit: "ce logement",
    property: "l'annonce",
  },

  preview: {
    boxText:
      "🔑 *{label} · {name}*\n\nLa boîte à clés s'ouvre avec le code : *{code}*\n\nÀ l'intérieur, vous trouverez les clés du logement. Merci de les y remettre à votre départ.",
    dynamicText:
      "🔒🔑 *{label} · {name}*\n\nVotre code d'accès est : *58117*\n\nValable pendant toute la durée de votre séjour.",
    staticText:
      "🔒🔑 *{label} · {name}*\n\nLe code de la serrure est : *{code}*\n\nUtilisez-le pour ouvrir la porte du logement.",
  },

  summary: {
    dynamic: "Serrure intelligente",
    codePrefix: "Code {code}",
    staticCode: "Code fixe",
    boxPrefix: "Boîte à clés {code}",
    empty: "Non configuré",
  },

  toast: {
    saved: "Accès enregistré",
    saveError: "La méthode d'accès n'a pas pu être enregistrée.",
    unified: "Configuration unifiée",
    unifyError: "La configuration n'a pas pu être unifiée.",
    savedRoom: "Accès enregistré · {room}",
    saveErrorRoom: "Impossible d'enregistrer l'accès pour {room}.",
    theRoom: "la chambre",
  },
};
